export default "__VITE_ASSET__f3950daa__"